<template>
  <div ref="box">
    <!-- 头部 -->
    <div class="bar-manager-header">
      <bar-header
        @refresh="refresh"
        @addRouterRemote="addRouterRemote"
      ></bar-header>
    </div>
    <!-- 表格部分 -->
    <div class="table-content">
      <bar-table-list
        ref="serverTable"
        @pagechange="getBarList"
        @addAllRouterRemote="addAllRouterRemote"
        @deleteAllRouter="deleteAllRouter"
        :total="parseInt(total)"
        :page="parseInt(page)"
        :loading="tableLoading"
        :table-list="tableData.list"
      ></bar-table-list>
    </div>
  </div>
</template>

<script>
// 头部
import BarHeader from '../../barHeader'
// 网吧列表
import BarTableList from '../../barTableList'

import { getBarList, deleteRouterBatch } from '@/requests/bar'

export default {
  name: 'allBar',
  components: {
    BarHeader,
    BarTableList,
  },
  data() {
    return {
      total: 0,
      page: 1,
      tableData: {
        list: [],
      },
      tableLoading: false,
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getBarList(1)
    })
  },
  methods: {
    // 获取最近远程的网吧列表
    async getBarList(pageNum) {
      this.tableData.list = []
      this.tableLoading = true
      let res = await getBarList({
        pageNum,
        pageSize: 20,
        flag: 'offline',
      })
      this.tableData.list = res.records
      this.total = parseInt(res.total)
      this.page = parseInt(res.current)
      this.tableLoading = false
    },
    addRouterRemote() {
      window.$modal.setRouterRemoteModal.show({ barId: [] }, 0)
    },
    deleteAllRouter() {
      if (this.$refs.serverTable.selectedBarIds().length == 0) {
        return window.$Message.show({
          title: '提示',
          type: 'info',
          msg: '请选择选择网吧',
        })
      }
      window.$Message.show({
        title: '删除全部路由',
        type: 'info',
        msg: '确认删除所有选中的网吧吗？',
        cancleBtn: true,
        confirmFn: async () => {
          let res = await deleteRouterBatch({
            barId: this.$refs.serverTable.selectedBarIds().join(','),
          })
          if (res.code === 200) {
            window.$Message.hide()
            this.getBarList(1)
          } else {
            window.$Message.hide()
            setTimeout(() => {
              window.$Message.show({
                title: '删除全部路由',
                type: 'error',
                msg: res.msg,
                confirmFn: () => {
                  window.$Message.hide()
                  window.$Message.confirmFn = null
                },
              })
            }, 100)
          }
        },
      })
    },
    addAllRouterRemote() {
      if (this.$refs.serverTable.selectedBarIds().length == 0) {
        return window.$Message.show({
          title: '提示',
          type: 'info',
          msg: '请选择选择网吧',
        })
      }
      window.$modal.setRouterRemoteModal.show(
        { barId: this.$refs.serverTable.selectedBarIds().join(',') },
        0,
        true
      )
    },
    async refresh() {
      await this.getBarList(this.page)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '_style/_color.scss';

.bar-manager-header {
  height: 70px;
  line-height: 70px;
  border-bottom: 1px solid #d9dee4;
}
.table-content {
  padding-top: 10px;
  padding-left: 30px;
  padding-right: 30px;
}
.table-pagination {
  text-align: right;
  padding-right: 80px;
  padding-top: 20px;
  > div {
    display: inline-block;
  }
}
</style>
